import { createSelector } from 'reselect'
import { excludeNullOrUndefined } from 'checkout/utils'
import { sum } from 'lib/array/arrayUtils'
import { getGiftCardItemsView } from 'checkout/selectors/view/giftCard'

export const getGiftCardTotals = createSelector(
  (state: App.State) => getGiftCardItemsView(state),
  (viewWithStatus): App.WithDataStatus<App.Checkout.ItemViewTotals> => {
    const definedItems = viewWithStatus.data.filter(excludeNullOrUndefined)
    return {
      hasRequiredData: viewWithStatus.hasRequiredData,
      data: {
        price: sum(definedItems, itemView => itemView.totals.price),
        memberPrice: 0,
        value: sum(definedItems, itemView => itemView.totals.value),
        surcharge: 0,
        taxesAndFees: 0,
        memberValue: 0,
        extraGuestSurcharge: 0,
      },
    }
  },
)
